<template>
  <div class="about">
    <page-header :title="$t('sponsor.edit')" :desc="model.name">
      <li class="breadcrumb-item"><router-link :to="{name:'sponsors.index'}">{{$tc('sponsor.name', 2)}}</router-link></li>
      <li class="breadcrumb-item">{{model.name}}</li>
    </page-header>
    <page-content>
      <form @submit.prevent="onSubmit()">
        <ntm-block :title="$t('sponsor.bannerLandingPage')" :init-collapse="false">
          <template slot="options">
            <span>{{ $t('ratio') }}: <span class="font-weight-bold">39:5</span>, {{ $t('size') }}: <span class="font-weight-bold">468x60 - 1404x180</span></span>
          </template>
          <ntm-crop entity-type="sponsor" :entity-uuid="$route.params.uuid" :aspect-ratio="39/5" :max-width="1404" :max-height="180" :min-width="468" :min-height="60" conversion="lg" collection="banner"></ntm-crop>
        </ntm-block>
        <ntm-block :title="$t('sponsor.logoLandingPage')" :init-collapse="false">
          <template slot="options">
            <span>{{ $t('ratio') }}: <span class="font-weight-bold">6:5</span>, {{ $t('size') }}: <span class="font-weight-bold">120x100 - 300x250</span></span>
          </template>
          <ntm-crop entity-type="sponsor" :aspect-ratio="6/5" :max-width="300" :max-height="250" :min-width="120" :min-height="100" :entity-uuid="$route.params.uuid" conversion="lg" collection="logo" ></ntm-crop>
        </ntm-block>
        <ntm-block :title="$t('sponsor.livestreamLogo')" :init-collapse="false">
          <template slot="options">
            <span>{{ $t('ratio') }}: <span class="font-weight-bold">{{$t('any')}}</span>, {{ $t('size') }}: <span class="font-weight-bold">100x100 - 500x500</span></span>
          </template>
          <ntm-crop entity-type="sponsor" :max-width="500" :max-height="500" :min-width="100" :min-height="100" :entity-uuid="$route.params.uuid" collection="broadcast"></ntm-crop>
        </ntm-block>
<!--        <ntm-block :title="$tc('crest')" :init-collapse="false">-->
<!--          <template slot="options">-->
<!--            <span>{{ $t('ratio') }}: <span class="font-weight-bold">1:1</span>, {{ $t('size') }}: <span class="font-weight-bold">500x500</span></span>-->
<!--          </template>-->
<!--          <ntm-crop entity-type="sponsor" :entity-uuid="$route.params.uuid" conversion="lg" collection="crest" :circle="true"></ntm-crop>-->
<!--        </ntm-block>-->
        <ntm-block>
          <formly-form :form="form" :model="model" :fields="fields"></formly-form>
          <button class="btn btn-success push-15">{{$t('save')}}</button>
        </ntm-block>
      </form>
    </page-content>
  </div>
</template>

<script>
import fields from './formDefinition'
import SponsorService from '@/services/sponsor.service'
import router from '@/router'

export default {
  // required properties, field, form, model
  data () {
    return {
      form: {},
      model: {},
      fields: fields,
      uploading: false
    }
  },
  beforeRouteEnter (to, from, next) {
    SponsorService.show(to.params.uuid).then((response) => {
      next(vm => vm.setData(response.data))
    })
  },
  // beforeRouteUpdate (to, from, next) {
  //   SponsorService.show(to.params.uuid).then((response) => {
  //     this.setData(response.data)
  //     store.commit('loaded')
  //   })
  // },
  methods: {
    setData (data) {
      this.model = data
    },
    updateLogo () {
      SponsorService.show(this.$route.params.uuid).then((response) => {
        this.uploading = false
        this.model.logo = response.data.logo
      })
    },
    onSubmit () {
      SponsorService.update(this.model.uuid, this.model).then(() => {
        router.push({ name: 'sponsors.index' })
      }).catch((err) => {
        this.form.$errors = err.response.data.errors
      })
    }
  }
}
</script>
